<template>
  <page>
<commonbanner></commonbanner>
<article id="page-expert">
  <section class="container container-main">
    <div class="subtitle">
       <Collection
      name="experttype"
      v-slot="{ collection }"
      :filter="{ item_id: typename }"
    >
      <h2>{{collection[0].item_name}}</h2>
 </Collection>
      <hr class="underline">
    </div>
    <div class="Team">
      <div class="TeamList">
        <Collection
          name="expert"
          :page="provider.current"
          :limit="provider.defaultPageSize"
          v-slot="{ collection, count }"
          :query="{ government_provider_class : typename }">
        <Experter :refObj="collection"></Experter>
            <div class="tabs_pagination">
                  <a-pagination
                      show-quick-jumper
                      :current="provider.current"
                      :defaultPageSize="provider.defaultPageSize"
                      :total="count"
                      @change="onChange"
                    />
              </div>
          </Collection>
      </div>
    </div>
  </section>
</article>
  </page>
</template>
<script>
import Collection from '@/components/Collection'
import Experter from '@/components/base/Experter'
import Commonbanner from '@/components/base/Commonbanner'
export default {
  name: 'ExpertQuery',
  components: {
    Commonbanner,
    Collection,
    Experter
  },
  data () {
    return {
      lawActive: '0176141e93568a8380377603faf907ff',
      typename: this.$route.params.typename,
      provider: {
        current: 1,
        defaultPageSize: 12,
        limit: 1
      },
      providerClass: ['宪法及相关法类', '行政法类', '民商法类', '经济法类', '社会法类', '诉讼与非诉讼程序法类'],
      public_provider_class: ['律师服务类', '公证服务类', '司法鉴定类', '法律援助类', '人民调解类', '仲裁服务类', '法治宣传类', '基层法律服务类', '法律职业资格考试类', '法律服务志愿者类', '公共法律服务理论研究类', '公共法律服务创新发展类']
    }
  },
  methods: {
    onChange (page, pageSize) {
      this.provider.current = this.provider.limit = page
    }
  },
  activated () {
    this.typename = this.$route.params.typename
  }
}
</script>
<style scoped src="../../assets/css/expert.css"></style>
